import apiUtils from '../apiUtils';

const service = {};
const serviceName = 'changePassword';

service.post = password => {
  const body = {
    password,
  };
  return apiUtils.exec(serviceName + '/', apiUtils.getFetchParameters('POST', body));
};

export default service;